export default __webpack_public_path__ + "static/media/cta-team.342624cb.png";